import { render, staticRenderFns } from "./ManualTask.vue?vue&type=template&id=0808e8b6&scoped=true"
import script from "./ManualTask.vue?vue&type=script&lang=js"
export * from "./ManualTask.vue?vue&type=script&lang=js"
import style0 from "./ManualTask.vue?vue&type=style&index=0&id=0808e8b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0808e8b6",
  null
  
)

export default component.exports